import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';
// CUSTOM-START: stock-locations
// Imported directly rather than through src/components/index.js: this file already
// pulls Heading and Map from the barrel, and adding a container-level import cycle
// is not worth the tidiness.
import PickupInfo from '../../components/PickupInfo/PickupInfo';
// CUSTOM-END: stock-locations

import css from './ListingPage.module.css';

// CUSTOM-START: hide-listing-map
// Clastique shows no map on the listing page. Only the collection address stays,
// and PickupInfo renders it only when pickup is on.
const SHOW_LISTING_MAP = false;
// CUSTOM-END: hide-listing-map

/**
 * The SectionMapMaybe component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {propTypes.uuid} props.listingId - The listing id
 * @returns {JSX.Element} section map maybe component
 */
class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig } = this.props;

    // CUSTOM-START: hide-listing-map
    if (!SHOW_LISTING_MAP) {
      return (
        <PickupInfo className={classNames(css.sectionMap, className)} publicData={publicData} />
      );
    }
    // CUSTOM-END: hide-listing-map

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    return (
      <section className={classes} id="listing-location">
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </Heading>
        {this.state.isStatic ? (
          <button
            className={css.map}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.map}>{map}</div>
        )}
        {/* CUSTOM-START: stock-locations */}
        {/* SL14: fuzzy is on marketplace-wide (D6), and the fuzzy branch above
            drops the address from the map props. A buyer cannot collect from a
            500 m circle, so print the collection address as text. */}
        <PickupInfo publicData={publicData} />
        {/* CUSTOM-END: stock-locations */}
      </section>
    );
  }
}

export default SectionMapMaybe;
